var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var treeDashboardsAndLocations = require ('../../components/treeDashboardsAndLocations');
var DestinationTypes = treeDashboardsAndLocations.DestinationTypes;

var moveDashboardModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function isHasDashboardEdge(edgeRecord) {
  if (!edgeRecord || typeof edgeRecord['@class'] !== 'string') {
    return false;
  }
  return edgeRecord['@class'].toLowerCase() === 'hasdashboard';
}

function getRequestErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.error) return error.error;
  if (error.message) return error.message;
  if (error.body && error.body.error) return error.body.error;
  return '';
}

moveDashboardModal.editDialogue = function (record, options) {
  moveDashboardModal.containsRecord = record;
  moveDashboardModal.showLocationSelector = options && options.showLocationSelector === false ? false : true;
  moveDashboardModal.showDashboardSelector = !isHasDashboardEdge(record);
  if (!moveDashboardModal.showDashboardSelector && !moveDashboardModal.showLocationSelector) {
    moveDashboardModal.showLocationSelector = true;
  }
  moveDashboardModal.selection = prop({
    type: moveDashboardModal.showDashboardSelector ? DestinationTypes.DASHBOARD : DestinationTypes.LOCATION,
    record: record.out
  });
  moveDashboardModal.error = prop('');

  var submit = () => {
    moveDashboardModal.error('');
    var selection = moveDashboardModal.selection() || {};
    var targetNode = selection.record;

    if (!targetNode || !targetNode['@rid']) {
      moveDashboardModal.error('Please select a dashboard or location to move this dashboard to.');
      return Promise.resolve();
    }

    if (selection.type === DestinationTypes.DASHBOARD && !moveDashboardModal.showDashboardSelector) {
      moveDashboardModal.error('Dashboards attached to locations can only be moved to locations.');
      return Promise.resolve();
    }

    var request = selection.type === DestinationTypes.DASHBOARD ?
      moveDashboardModal.moveToDashboard(targetNode) :
      moveDashboardModal.moveToLocation(targetNode);

    return request
    .then(function () {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(function (error) {
      console.error('Unable to move dashboard', error);
      moveDashboardModal.error(getRequestErrorMessage(error) || 'Unable to move the dashboard. Please try again.');
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Move Dashboard: ')
  modal.vm.body = moveDashboardModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


moveDashboardModal.view = function () {
  return m('form', {role:'form'}, [
    m(treeDashboardsAndLocations, {
      selector: moveDashboardModal.selection,
      showDashboards: moveDashboardModal.showDashboardSelector,
      showLocations: moveDashboardModal.showLocationSelector,
      onSelect: function () {
        moveDashboardModal.error('');
      }
    }),
    moveDashboardModal.error() ? m('div.red.mt2', moveDashboardModal.error()) : ''
  ])  
}

moveDashboardModal.moveToLocation = function (locationNode) {
  return loaders.requestWithLoader({
    loader: 'submit',
    url: '/api/v1/dashboard/'+ moveDashboardModal.containsRecord.in['@rid'].slice(1) + '/movetolocation',
    method: 'PUT',
    body:{ 
      containsEdgeRid: moveDashboardModal.containsRecord['@rid'],
      locationRid: locationNode['@rid']
    }
  });
};

moveDashboardModal.moveToDashboard = function (dashboardNode) {
  if (isHasDashboardEdge(moveDashboardModal.containsRecord)) {
    return loaders.requestWithLoader({
      loader: 'submit',
      url: '/api/v1/dashboard/'+ moveDashboardModal.containsRecord.in['@rid'].slice(1) + '/movetodashboard',
      method: 'PUT',
      body:{
        currentEdgeRid: moveDashboardModal.containsRecord['@rid'],
        parentDashboardRid: dashboardNode['@rid']
      }
    });
  }

  return loaders.requestWithLoader({
    loader: 'submit',
    url: '/api/v1/contains/'+ moveDashboardModal.containsRecord['@rid'].slice(1),
    method: 'PUT',
    body:{ 
      out: dashboardNode['@rid'].slice(1),
      in: moveDashboardModal.containsRecord.in['@rid']
    }
  });
};

module.exports = moveDashboardModal;
